import { useQuery } from "@tanstack/react-query";

import { api, errorMessage } from "../api/client";

export type Widget = { key: string; title: string; size: "sm" | "md" | "lg"; spoke: string; data: Record<string, unknown> };

export function useDashboard() {
  return useQuery({
    queryKey: ["dashboard"],
    queryFn: async () => {
      const { data, error } = await api.GET("/api/dashboard/");
      if (error) throw new Error(errorMessage(error));
      return (data?.widgets ?? []) as unknown as Widget[];
    },
    refetchInterval: 60_000,
  });
}
